import * as React from "react";
const ColorDropBold = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.896,16 C9.042,16 8.3,14.881 8.3,13.5 C8.3,12.12 8.979,11 10.896,11 L10.896,16 Z M11.5,5 C11.5,5 6,9.121 6,13.709 C6,16.771 8.517,19 11.523,19 C14.53,19 17,16.771 17,13.709 C17,9.121 11.5,5 11.5,5 L11.5,5 Z" }));
ColorDropBold.displayName = "ColorDropBold";
var ColorDropBold_default = ColorDropBold;
export {
  ColorDropBold_default as default
};
